import PagePlaceholder from "@/components/page-placeholder"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import PhysicalRiskEditModal from "@/entities/physical-risk/ui/modal/PhysicalRiskEditModal"
import RiskFamiliesFilterPanel from "@/entities/risk-family/ui/RiskFamiliesFilterPanel"
import physicalRiskStore from "@/entities/physical-risk/model/physical-risk.store"
import riskFamilyStore from "@/entities/risk-family/model/risk-family.store"
import RiskFamilyOverview from "@/entities/risk-family/ui/RiskFamilyOverview"
import { RISK_FAMILIES_PATH } from "@/entities/risk-family/model/risk-family.utils"
import { faPlus } from "@fortawesome/free-solid-svg-icons"
import { useLayoutEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import NavEstablishment from "@/nav/nav.establishment"
import { useRisksSpace } from "@/core/risks-space.context"

export default function RisksFamilyRoute() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { familyId } = useParams()
  const { getPath } = useRisksSpace()
  const parentPath = getPath(RISK_FAMILIES_PATH)
  const families = useAppSelector(physicalRiskStore.selectors.listFamilies)
  const activeFamily = useAppSelector(riskFamilyStore.selectors.active)
  const isFamilyActive = useAppSelector(riskFamilyStore.selectors.isActive)
  const [isAddModalOpen, setIsAddModalOpen] = useState(false)

  //Ne dispatcher que sur un changement reel de famille : la reference de "families" change a chaque
  //mutation de la slice physicalRisk, donc un dispatch inconditionnel se rappellerait lui-meme des
  //que la liste des familles serait triee (sort.key non nul), en boucle.
  useLayoutEffect(() => {
    const family = families.find((item) => item.id === familyId) ?? null
    const activeFamilyId = isFamilyActive ? activeFamily.id : null

    if ((family?.id ?? null) !== activeFamilyId) dispatch(riskFamilyStore.actions.setActive(family))
  }, [activeFamily.id, dispatch, families, familyId, isFamilyActive])

  function closeOverview() {
    dispatch(riskFamilyStore.actions.setActive(null))
  }

  //La modification et la suppression d'une famille se font depuis la page des echelles de risques.
  const actions = [
    {
      id: "ADD_RISK",
      icon: faPlus,
      label: "Ajouter risque",
      className: "primary" as const,
      isLarge: true,
      onClick: () => setIsAddModalOpen(true)
    }
  ]

  return (
    <NavEstablishment actions={actions} onTabClick={closeOverview}>
      {isAddModalOpen && isFamilyActive && (
        <PhysicalRiskEditModal
          onClose={() => setIsAddModalOpen(false)}
          context={{ type: "family", family: activeFamily }}
        />
      )}

      <div className="flex fixed top-[48px] left-0 h-[calc(100%-48px)] app-content-width">
        <div className="flex-1 min-w-0">
          {isFamilyActive ? (
            <RiskFamilyOverview />
          ) : (
            <PagePlaceholder
              title="Famille de risques introuvable"
              button="Retour aux familles de risques"
              onClick={() => navigate(parentPath)}
            />
          )}
        </div>
        <RiskFamiliesFilterPanel />
      </div>
    </NavEstablishment>
  )
}
